import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToDocumentCalculated = (
  documentId: AnyDocument['id'],
  onCalculated: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.Calculated],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildDocumentChannelName(documentId),
    DocumentPrivateWebsocketEvent.Calculated,
    onCalculated,
  );
};
